<template>
  <section
    class="contacts-wrapper flex flex-row"
    :class="{'announcement-space': showAnnouncement }">
    <ContactsTable
      class="greedy"/>
    <RightPanel
      :menu-acts-as-toggle="false"
      initial-section="info"
      class="panel"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

import ContactsTable from './ContactsTable';
import RightPanel from '../contact_details/RightPanel';

export default {
  name: 'Contacts',
  components: {
    RightPanel,
    ContactsTable,
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters({
      showAnnouncement: 'system/showAnnouncement',
    }),
  },
  destroyed() {
    this.$store.commit('resetContactData');
  },
};
</script>

<style lang="scss" scoped>

.contacts-wrapper {
  background-color: $white;
  align-items: stretch;
  width: calc(100% - 258px);
  z-index: 998;
}

</style>
